import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createBaseSelector, registerSlice } from "shared/lib/redux";
import { ParcelSearchCardModel } from "./model";

type ParcelSearchCard = ParcelSearchCardModel[];

const initialAppState: ParcelSearchCard = [];

const parcelSearchCardSlice = createSlice({
  name: "parcelSearchCards",
  initialState: initialAppState,
  reducers: {
    prependSearchCardAction: (
      state,
      { payload: { data, unique = true } }: PayloadAction<{ data: ParcelSearchCardModel; unique?: boolean }>
    ) => {
      if (unique) {
        const foundCard = state.find((card) => card.reference === data.reference);
        if (foundCard) return;
      }
      state.unshift(data);
    },
    removeSearchCardAction: (state, action: PayloadAction<ParcelSearchCardModel>) => {
      return state.filter((card) => card.reference !== action.payload.reference);
    },
    updateSearchCardAction: (state, action: PayloadAction<ParcelSearchCardModel>) => {
      const targetCard = state.findIndex((card) => card.reference === action.payload.reference);
      if (targetCard !== -1) {
        state[targetCard] = action.payload;
      }
    },
  },
});

const parcelSearchCardBaseSelector = createBaseSelector(parcelSearchCardSlice);

registerSlice([parcelSearchCardSlice]);

export const parcelSearchCardStore = {
  actions: parcelSearchCardSlice.actions,
  selectors: {
    searchCards: createSelector(parcelSearchCardBaseSelector, (s) => s),
  },
};
